var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CoherenceNav } from '@cseo/controls/lib/nav';
import { useCoherenceNavGroups } from './useCoherenceNavGroups';
import { ComponentContext } from '@employee-experience/common/lib/ComponentContext';
import { EventType, UsageEventName } from '@employee-experience/common/lib/Models';
export function Nav(props) {
    const { groups, defaultIsNavCollapsed, appName } = props, otherProps = __rest(props, ["groups", "defaultIsNavCollapsed", "appName"]);
    const { telemetryClient } = React.useContext(ComponentContext);
    const coherenceNavGroups = useCoherenceNavGroups(groups);
    const onToggle = (isOpen) => {
        const navigationEvent = {
            subFeature: `Navigation.SideNav.${isOpen ? 'Open' : 'Close'}`,
            type: EventType.User,
            eventName: UsageEventName.LinkClicked,
        };
        telemetryClient.trackEvent(navigationEvent, Object.assign({}, props));
        if (props.onNavCollapsed)
            props.onNavCollapsed(isOpen);
    };
    return (React.createElement(CoherenceNav, Object.assign({}, otherProps, { appName: appName || '', groups: coherenceNavGroups, onNavCollapsed: (isOpen) => onToggle(isOpen), defaultIsNavCollapsed: defaultIsNavCollapsed === undefined ? true : defaultIsNavCollapsed, telemetryHook: telemetryClient })));
}
//# sourceMappingURL=Nav.js.map